enum DmsSyncStatusType {
  NOSYNC = 'NOSYNC',
  SYNCOK = 'SYNCOK',
  SYNCFAILED = 'SYNCFAILED',
}

export default DmsSyncStatusType;